<template>
<div>
    <plant-variety-list></plant-variety-list>
</div>
</template>

<script>
export default {}
</script>
